module.exports = __webpack_public_path__ + "static/logo-4f82d778248192cef0ab9db3853779b4.png";